/* global firebase */
import { db } from "../../firebase/firebase";

export const updateApiKey = ({ apiKeyId, changes }) => {
    db.collection("apiKeys")
        .doc(apiKeyId)
        .set(changes, { merge: true });
}

export const addApiKey = async ({ name }) => {
    const generateApiKey = firebase.functions().httpsCallable('generateApiKey');
    return await generateApiKey({ name })
}

export const deleteApiKey = async ({ apiKeyId }) => {
    const deleteApiKey = firebase.functions().httpsCallable('deleteApiKey');
    return await deleteApiKey({ apiKeyId })
}